<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">
      <q-btn @click="$emit('close')" flat>
        <q-icon name="mdi-arrow-left"> </q-icon>
      </q-btn>
      Finals Progression
    </div>
    <div class="col-12">
      <div
        class="row"
        v-if="
          currentEventRounds &&
            currentEventRounds.rounds &&
            currentEventRounds.rounds.length > 0
        "
      >
        <div class="col-12 q-pa-sm">
          <q-card>
            <q-card-section>
              <div class="row items-center">
                <div class="col-12 col-sm-3 col-md-3 q-px-xs">
                  <span> Qual/Race </span>
                  <q-select
                    :disable="
                      useTimes
                        ? true
                        : currentEventRounds.num_lanes >=
                            registeredParticipants.length ||
                          currentEventRounds.rounds.length != 1
                    "
                    v-model="qualPerRace"
                    v-bind="siteCFG.fields.general"
                    :options="qualPerRaceOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                </div>
                <div class="col-12 col-sm-3 col-md-3 q-px-xs">
                  <span> Total Qualifiers </span>
                  <q-select
                    v-if="
                      useTimes
                        ? true
                        : currentEventRounds.num_lanes >=
                            registeredParticipants.length ||
                          currentEventRounds.rounds.length != 1
                    "
                    :disable="
                      currentEventRounds.rounds.length == 1 &&
                        (!event.combinedEvents ||
                          event.combinedEvents.length == 0) &&
                        !useTimes &&
                        currentEventRounds.num_lanes <=
                          registeredParticipants.length
                    "
                    v-model="totalQual"
                    v-bind="siteCFG.fields.general"
                    :options="totalQualOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                  <p v-else class="q-mt-sm q-mb-none">
                    {{ filteredParticipants.length }}
                  </p>
                </div>
                <div class="col-12 col-sm-6 col-md-3 q-px-xs">
                  <span> Progress To </span>
                  <q-select
                    :disable="
                      currentEventRounds.rounds.length == 1 &&
                        (currentEventRounds.num_lanes >=
                          registeredParticipants.length ||
                          currentEventRounds.rounds.length != 1) &&
                        (!event.combinedEvents ||
                          event.combinedEvents.length == 0)
                    "
                    v-model="progressTo"
                    v-bind="siteCFG.fields.general"
                    :options="progressToOptions"
                    option-label="label"
                    option-value="value"
                    :emit-value="true"
                    map-options
                    dense
                  >
                  </q-select>
                </div>
                <div class="col-12 col-md-3 q-pa-xs">
                  <q-checkbox
                    dense
                    v-model="excludeDQ"
                    label="Exclude DQ, DNS, DNF, DNR"
                  >
                  </q-checkbox>
                  <q-btn
                    class="bg-primary text-white full-width q-mt-xs"
                    @click="createLanes"
                    :loading="lanesDrawing"
                    dense
                    :disabled="errorMessage"
                    no-caps
                  >
                    Submit
                  </q-btn>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-12" v-if="!errorMessage">
          <q-scroll-area style="height: calc(100vh - 455px) !important">
            <div class="row">
              <p
                class="text-red text-bold"
                v-if="
                  (currentEventRounds.rounds[0].races.length * qualPerRace >
                  registeredParticipants.length
                    ? registeredParticipants.length
                    : currentEventRounds.rounds[0].races.length * qualPerRace) >
                    placingsData.length
                "
              >
                Please make sure your total Qualifiers doesn't exceed the
                participants in the list below.
              </p>
              <p
                class="text-red text-bold"
                v-if="useTimes && totalQual > placingsData.length"
              >
                Please make sure your total Qualifiers doesn't exceed the
                participants in the list below.
              </p>
            </div>
            <div
              class="row"
              v-if="
                progressToRoundStructureLookup[progressTo].round &&
                  (currentEventRounds.num_lanes <
                    registeredParticipants.length ||
                    currentEventRounds.rounds.length != 1) &&
                  progressTo < 5
              "
              v-for="(round, index) in progressToRoundStructureLookup[
                progressTo
              ].rounds"
              :key="`progressToRounds_${index}`"
            >
              <div class="col-12">{{ round.label }}</div>

              <div
                class="q-pa-md"
                v-for="(card, cardIndex) in round.cards"
                :key="`card_${cardIndex}`"
              >
                <q-card style="width: 100px">
                  <q-card-section>
                    <b>{{ card.label }}</b>
                    {{ card.participants }}
                  </q-card-section>
                </q-card>
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 mt-0 pt-0"
                :style="
                  `height: calc(100vh - ${
                    progressTo < 5 ? '565px' : '465px'
                  }) !important`
                "
              >
                <datatable
                  :filter="search"
                  :flat="true"
                  :data="placingsData"
                  :columns="columns"
                  @rowDoubleClick="handleDoubleClick"
                  :hidePagination="true"
                >
                  <template slot="body-cell-qualified" slot-scope="data">
                    <q-td :props="data.props">
                      <q-icon
                        size="sm"
                        :name="
                          totalQual
                            ? `${
                                data.props.rowIndex < totalQual &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                            : currentEventRounds.rounds[0].races.length *
                                qualPerRace >
                              registeredParticipants.length
                            ? `${
                                data.props.rowIndex <
                                  registeredParticipants.length &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                            : `${
                                data.props.rowIndex <
                                  currentEventRounds.rounds[0].races.length *
                                    qualPerRace &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                        "
                        :color="
                          totalQual
                            ? `${
                                data.props.rowIndex < totalQual &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'positive'
                                  : 'negative'
                              }`
                            : currentEventRounds.rounds[0].races.length *
                                qualPerRace >
                              registeredParticipants.length
                            ? `${
                                data.props.rowIndex <
                                  registeredParticipants.length &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'positive'
                                  : 'negative'
                              }`
                            : `${
                                data.props.rowIndex <
                                  currentEventRounds.rounds[0].races.length *
                                    qualPerRace &&
                                (!data.props.row.placing.includes('D') ||
                                  !excludeDQ)
                                  ? 'positive'
                                  : 'negative'
                              }`
                        "
                      ></q-icon>
                    </q-td>
                  </template>
                </datatable>
              </div>
            </div>
          </q-scroll-area>
        </div>
        <div v-else>
          <q-card class="q-pa-md text-bold text-center" flat bordered>
            <q-icon name="mdi-alert-outline" size="lg" color="orange"></q-icon>
            <br />
            {{ errorMessage }}
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";

// import { Notify } from "quasar";

export default {
  components: { datatable },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      registeredParticipants: "events/registeredParticipants",
      event: "events/current",
      currentEventRounds: "eventProgress/currentEventRounds",
      competition: "competitions/current"
    }),
    filteredParticipants: function() {
      return this.placingsData.filter((p, index) => {
        if (p.placing.includes("D") && this.excludeDQ) {
          return false;
        }

        if (this.totalQual && index < this.totalQual) {
          return true;
        }

        if (
          this.currentEventRounds.rounds[0].races.length * this.qualPerRace >
            this.registeredParticipants.length &&
          index < this.registeredParticipants.length
        ) {
          return true;
        }

        if (
          index <
          this.currentEventRounds.rounds[0].races.length * this.qualPerRace
        ) {
          return true;
        }

        return false;
      });
    },
    columns: function() {
      return [
        {
          name: "rank",
          label: "Rank",
          align: "left",
          field: "rank",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          hide:
            this.currentEventRounds &&
            this.currentEventRounds.rounds.length == 1 &&
            !this.useTimes
        },
        {
          name: "placing",
          label: "Placing",
          align: "left",
          field: "placing",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          hide:
            this.useTimes ||
            !this.currentEventRounds ||
            this.currentEventRounds.rounds.length != 1
        },
        {
          name: "event_rank",
          label: "Event Rank",
          align: "left",
          field: "event_rank",
          hide:
            true ||
            !this.event.combinedEvents ||
            this.event.combinedEvents.length == 0,
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 180px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "association_abbr",
          label: "Club",
          align: "left",
          field: "association_abbr",
          style:
            "min-width: 180px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },

        {
          name: "points",
          label: "Points",
          align: "left",
          field: "points",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          hide:
            this.useTimes ||
            (this.currentEventRounds &&
              this.currentEventRounds.rounds.length == 1)
        },
        {
          name: "master_time",
          label: "Time",
          align: "left",
          field: "master_time",
          hide: !this.useTimes,
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "wins",
          label: "Wins",
          align: "left",
          field: "wins",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis",
          sortable: true,
          hide:
            this.useTimes ||
            (this.currentEventRounds &&
              this.currentEventRounds.rounds.length == 1)
        },
        {
          name: "worstPos",
          label: "Worst PL",
          align: "left",
          field: "worstPos",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          hide:
            this.useTimes ||
            (this.currentEventRounds &&
              this.currentEventRounds.rounds.length == 1)
        },
        {
          name: "qualified",
          label: "Qualified",
          align: "left",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        }
      ];
    }
  },
  data: () => ({
    qualPerRace: 0,
    totalQual: 0,
    progressTo: 0,
    qualPerRaceOptions: [
      {
        label: "None",
        value: 0
      }
    ],
    totalQualOptions: [
      {
        label: "None",
        value: 0
      }
    ],
    progressToOptions: [
      {
        label: "Choose",
        value: 0
      },
      {
        label: "1x Final",
        value: 1
      },
      {
        label: "2x Semi",
        value: 2
      },
      {
        label: "3x Semi",
        value: 3
      },
      {
        label: "3x Quater",
        value: 7
      },
      {
        label: "4x Quater",
        value: 4
      },
      {
        label: "5x Quater",
        value: 8
      },
      {
        label: "6x Quater",
        value: 9
      },
      {
        label: "7x Quater",
        value: 10
      },
      {
        label: "Placings by Points",
        value: 5
      },
      {
        label: "Placings by Time",
        value: 6
      }
    ],
    progressToRoundStructureLookup: [
      {
        round: false
      },
      {
        round: true,
        rounds: [
          {
            label: "Final",
            cards: [
              {
                label: "F1",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Semi Finals",
            cards: [
              {
                label: "S1",
                participants: 0
              },
              {
                label: "S2",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Semi Finals",
            cards: [
              {
                label: "S1",
                participants: 0
              },
              {
                label: "S2",
                participants: 0
              },
              {
                label: "S3",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Final",
            isPlacingsRound: 1,
            cards: [
              {
                label: "F1",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Final",
            isPlacingsRound: 1,
            cards: [
              {
                label: "F1",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              },
              {
                label: "Q6",
                participants: 0
              }
            ]
          }
        ]
      },
      {
        round: true,
        rounds: [
          {
            label: "Quarter Finals",
            cards: [
              {
                label: "Q1",
                participants: 0
              },
              {
                label: "Q2",
                participants: 0
              },
              {
                label: "Q3",
                participants: 0
              },
              {
                label: "Q4",
                participants: 0
              },
              {
                label: "Q5",
                participants: 0
              },
              {
                label: "Q6",
                participants: 0
              },
              {
                label: "Q7",
                participants: 0
              }
            ]
          }
        ]
      }
    ],

    search: "",
    placingsData: [],
    lanesDrawing: false,

    eventCount: 0,

    useTimes: false,

    additionalQual: [],
    excludeQual: [],

    errorMessage: null,

    excludeDQ: false
  }),
  watch: {
    useTimes: function() {
      if (this.useTimes) {
        this.qualPerRace = 0;
        this.drawLanes();
      }
    },
    qualPerRace: function() {
      const customTotalQual = this.useTimes
        ? true
        : this.currentEventRounds.num_lanes >=
            this.registeredParticipants.length ||
          this.currentEventRounds.rounds.length != 1;

      const calcCustomTotal =
        this.currentEventRounds.rounds[
          this.currentEventRounds.rounds.length - 1
        ].races.length * this.qualPerRace;

      customTotalQual ? null : (this.totalQual = calcCustomTotal);
      this.drawLanes();
    },
    totalQual: function() {
      this.drawLanes();
    },
    progressTo: function() {
      this.generatePlacingsData();
      this.drawLanes();
    },
    registeredParticipants: function() {
      this.drawLanes();
    },
    currentEventRounds: function() {
      if (this.progressTo == 0) {
        let eventRoundsObject = JSON.parse(
          JSON.stringify(this.currentEventRounds)
        );
        this.qualPerRace = eventRoundsObject.qualPerRace;
        const customTotalQual = this.useTimes
          ? true
          : this.currentEventRounds.num_lanes >=
              this.registeredParticipants.length ||
            this.currentEventRounds.rounds.length != 1;

        const calcCustomTotal =
          this.currentEventRounds.rounds[
            this.currentEventRounds.rounds.length - 1
          ].races.length * this.qualPerRace;

        this.totalQual = customTotalQual
          ? eventRoundsObject.qualTotal
          : calcCustomTotal;
        this.progressTo = eventRoundsObject.rounds[0].progress_to;
      }
      this.drawLanes();
      this.generatePlacingsData();
    }
  },
  mounted() {
    this.$store.dispatch("events/loadRegisteredParticipants", this.event.id);
    this.$store
      .dispatch("eventProgress/loadCurrentEventRoundsObject", this.event.id)
      .then(() => {
        this.generatePlacingsData();
      });
    this.drawLanes();
  },
  methods: {
    handleDoubleClick() {},
    addMember() {},
    drawLanes() {
      if (this.currentEventRounds && this.currentEventRounds.rounds) {
        let eventRoundsObject = JSON.parse(
          JSON.stringify(this.currentEventRounds)
        );

        // Calculating the Qual Options
        this.totalQualOptions = [
          {
            label: "None",
            value: 0
          }
        ];

        // Populating the Total qual options list for dropdown
        this.registeredParticipants.forEach(element => {
          if (element.value == 1) {
            this.totalQualOptions.push({
              label: `${this.totalQualOptions.length}`,
              value: this.totalQualOptions.length
            });
          }
        });

        // Generating the Qualifiers per race dropdown List
        if (
          eventRoundsObject.num_lanes < this.registeredParticipants.length &&
          eventRoundsObject.rounds.length == 1
        ) {
          this.qualPerRaceOptions = [
            {
              label: "None",
              value: 0
            }
          ];
          for (
            let i = 1;
            i <= eventRoundsObject.rounds[0].races[0].lanes.length;
            i++
          ) {
            this.qualPerRaceOptions.push({
              label: `Top ${i}`,
              value: i
            });
          }
        } else {
          this.qualPerRace = 0;
        }

        if (
          this.progressToRoundStructureLookup[this.progressTo].round &&
          (eventRoundsObject.num_lanes < this.registeredParticipants.length ||
            eventRoundsObject.rounds.length != 1)
        ) {
          let totalQualifiers;
          if (
            eventRoundsObject.num_lanes >= this.registeredParticipants.length ||
            eventRoundsObject.rounds.length != 1 ||
            this.useTimes
          ) {
            // Calculating Total Qualifiers from Total Qualifiers drop down
            totalQualifiers = this.totalQual;
          } else {
            // Calculating Total Qualifiers from "Qualifiers Per Race"

            totalQualifiers =
              eventRoundsObject.rounds[0].races.length * this.qualPerRace;
            totalQualifiers =
              totalQualifiers > this.registeredParticipants.length
                ? this.registeredParticipants.length
                : totalQualifiers;
          }

          let qualPerRound = Math.floor(
            totalQualifiers /
              this.progressToRoundStructureLookup[this.progressTo].rounds[0]
                .cards.length
          );

          qualPerRound = qualPerRound == 0 ? 1 : qualPerRound;

          this.progressToRoundStructureLookup[
            this.progressTo
          ].rounds[0].cards.forEach(card => {
            card.participants =
              totalQualifiers >= qualPerRound ? qualPerRound : totalQualifiers;

            totalQualifiers = totalQualifiers - qualPerRound;
            totalQualifiers = totalQualifiers < 0 ? 0 : totalQualifiers;
          });

          for (let i = 0; i < totalQualifiers; i++) {
            this.progressToRoundStructureLookup[
              this.progressTo
            ].rounds[0].cards[i].participants += 1;
          }
        }
      }
    },

    generatePlacingsData() {
      if (this.currentEventRounds && this.currentEventRounds.rounds) {
        let members = [];
        let memberLinks = {};
        let isTeamEvent =
          JSON.parse(this.currentEventRounds.playerLabels).length > 1;

        JSON.parse(JSON.stringify(this.currentEventRounds)).rounds.forEach(
          round => {
            round.races.forEach(race => {
              race.lanes.forEach(lane => {
                if (lane.placing && lane.checked_in && !lane.scratched) {
                  // if (!lane.firstName) {
                  // console.log(lane);
                  // }
                  let memberIndex = 0;
                  // Cannot be !memberLinks[lane.participant_id] as index 0 will pass this check doubling the amount of entries
                  if (typeof memberLinks[lane.participant_id] == "undefined") {
                    memberLinks[lane.participant_id] = members.length;
                    memberIndex = members.length;
                    members.push({
                      rank: null,
                      id: lane.participant_id,
                      lane_id: lane.id,
                      events_id: lane.events_id,
                      event_name: lane.event_name,
                      name: isTeamEvent
                        ? lane.team_name
                        : `${lane.firstName} ${lane.lastName}`,
                      association_abbr: lane.association_abbr,
                      points: 0,
                      wins: 0,
                      worstPos: 0,
                      placing: lane.placing,
                      dqCode_id: lane.dqCode_id,
                      master_time: lane.master_time
                    });
                  } else {
                    memberIndex = memberLinks[lane.participant_id];
                  }
                  members[memberIndex].points += lane.points
                    ? parseInt(lane.points)
                    : 0;
                  members[memberIndex].wins +=
                    parseInt(lane.placing) == 1 ? 1 : 0;
                  members[memberIndex].worstPos =
                    parseInt(lane.placing) > members[memberIndex].worstPos
                      ? parseInt(lane.placing)
                      : members[memberIndex].worstPos;
                } else {
                  if (lane.checked_in && !lane.scratched) {
                    console.log(lane);
                    this.errorMessage =
                      "Not all competitors have been given a placing. Please ensure that everyone has been placed before moving onto the next stage of the event.";
                  } else {
                    // console.log(lane);
                  }
                }
              });
            });
          }
        );

        members.sort((a, b) => {
          if (
            a.placing &&
            a.placing.includes("D") &&
            JSON.parse(JSON.stringify(this.currentEventRounds)).rounds.length ==
              1
          )
            return 1; //If it is just a heat, then include DQ, DNS, DNR and DNF in placings
          if (
            a.placing &&
            b.placing.includes("D") &&
            JSON.parse(JSON.stringify(this.currentEventRounds)).rounds.length ==
              1
          )
            return -1; //If it is just a heat, then include DQ, DNS, DNR and DNF in placings
          let p1 = a.points;
          let p2 = b.points;

          let w1 = a.wins;
          let w2 = b.wins;

          let wp1 = a.worstPos;
          let wp2 = b.worstPos;

          if ((a.master_time && b.master_time) || this.progressTo == 6) {
            this.useTimes = true;
            if (!a.master_time) return 1;
            if (!b.master_time) return -1;

            let t1 = Number(
              a.master_time.replaceAll(":", "").replaceAll(".", "")
            );
            let t2 = Number(
              b.master_time.replaceAll(":", "").replaceAll(".", "")
            );
            if (isNaN(t1)) return 1;
            if (isNaN(t2)) return -1;
            if (t1 < t2) return -1;
            if (t1 > t2) return 1;
          }

          if (p1 < p2) return 1;
          if (p1 > p2) return -1;
          if (w1 < w2) return 1;
          if (w2 < w1) return -1;
          if (wp1 < wp2) return -1;
          if (wp2 < wp1) return 1;
          return 0;
        });

        // Calculating Rank

        let currentRank = 1;
        let eventPlacings = {};
        this.eventCount = 0;
        members.forEach((member, index) => {
          // Overall Placing
          if (index == 0) {
            currentRank = 1;
            member.rank = 1;
          } else if (
            member.placing.includes("D") &&
            JSON.parse(JSON.stringify(this.currentEventRounds)).rounds.length ==
              1 //If it is just a heat, then include DQ, DNS, DNR and DNF in placings
          ) {
            currentRank += 1;
            member.rank = member.placing;
          } else {
            let prevMember = members[index - 1];
            if (
              (prevMember.points == member.points &&
                prevMember.wins == member.wins &&
                prevMember.worstPos == member.worstPos &&
                this.progressTo != 6) ||
              (prevMember.master_time == member.master_time &&
                this.progressTo == 6)
            ) {
              members[index - 1].rank = Number.isInteger(prevMember.rank)
                ? `${prevMember.rank}=`
                : `${prevMember.rank}`;
              member.rank = `${prevMember.rank}`;
              currentRank += 1;
            } else {
              currentRank += 1;
              member.rank =
                this.currentEventRounds.rounds.length == 1
                  ? currentRank
                  : index + 1;
            }
          }

          // Per Event Placing
          if (!eventPlacings[member.events_id]) {
            this.eventCount += 1;
            member.event_rank = 1;
            eventPlacings[member.events_id] = {
              currentRank: 1,
              prevMember: JSON.parse(JSON.stringify(member)),
              prevMemberIndex: index
            };
          } else {
            let placingInfo = JSON.parse(
              JSON.stringify(eventPlacings[member.events_id])
            );
            if (
              (placingInfo.prevMember.points == member.points &&
                (this.progressTo == 5 ||
                  (placingInfo.prevMember.wins == member.wins &&
                    placingInfo.prevMember.worstPos == member.worstPos &&
                    this.progressTo != 6))) ||
              (placingInfo.prevMember.master_time == member.master_time &&
                member.master_time)
            ) {
              members[
                eventPlacings[member.events_id].prevMemberIndex
              ].event_rank = Number.isInteger(placingInfo.prevMember.event_rank)
                ? `${placingInfo.prevMember.event_rank}=`
                : `${placingInfo.prevMember.event_rank}`;
              member.event_rank = `${placingInfo.prevMember.event_rank}=`;
              eventPlacings[member.events_id].currentRank += 1;
              eventPlacings[member.events_id].prevMember = JSON.parse(
                JSON.stringify(member)
              );
              eventPlacings[member.events_id].prevMemberIndex = index;
            } else {
              eventPlacings[member.events_id].currentRank += 1;
              member.event_rank = eventPlacings[member.events_id].currentRank;
              eventPlacings[member.events_id].prevMember = JSON.parse(
                JSON.stringify(member)
              );
              eventPlacings[member.events_id].prevMemberIndex = index;
            }
          }
        });

        this.placingsData = members;
      }
    },

    createLanes() {
      this.lanesDrawing = true;
      // console.log(this.generateLanes());

      let payload = {
        progressTo: this.progressTo,
        qualPerRace: this.qualPerRace,
        totalQual: this.totalQual,
        events_id: this.$route.params.events_id,
        rounds: this.generateLanes(),
        combinedEventsPlacings:
          this.eventCount > 1 && (this.progressTo == 5 || this.progressTo == 6)
      };

      // console.log(this.generateLanes());
      // this.lanesDrawing = false;

      this.$store
        .dispatch("eventProgress/drawLanesFinals", payload)
        .then(result => {
          this.lanesDrawing = false;

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadRounds",
              this.$route.params.events_id
            );
            this.$emit("close");
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },

    generateLanes() {
      let participantsList = this.filteredParticipants;

      if (
        this.eventCount > 1 &&
        (this.progressTo == 5 || this.progressTo == 6)
      ) {
        return this.generateCombinedEventPlacingLanes(participantsList);
      } else {
        if (
          (!this.competition.lane_order_type ||
            this.competition.lane_order_type == "Random") &&
          this.progressTo != 5 &&
          this.progressTo != 6
        ) {
          participantsList = this.$options.filters.shuffle(participantsList);
        }
        // Normal Event or not placing progression
        let rounds = this.progressToRoundStructureLookup[this.progressTo]
          .rounds;

        rounds.forEach((round, ri) => {
          let pi = 0;
          round.roundPos = ri;
          round.heats = [];

          round.cards.forEach((card, hi) => {
            let heat = {
              label: card.label,
              heatPos: hi,
              participants: []
            };

            // If progress to placings by points, then order everyone by the placings chart
            let localPi = 0;

            for (pi; localPi < card.participants; pi += round.cards.length) {
              if (participantsList[pi]) {
                heat.participants.push({
                  id: participantsList[pi].id,
                  events_id: participantsList[pi].events_id,
                  lane_id: participantsList[pi].lane_id,
                  name: participantsList[pi].name,
                  lane: localPi + this.competition.first_lane_no,
                  pos: pi,
                  master_time: participantsList[pi].master_time,
                  dqCode_id: participantsList[pi].dqCode_id,
                  placing:
                    typeof participantsList[pi].rank == "string"
                      ? participantsList[pi].rank.replace("=", "")
                      : participantsList[pi].rank
                });
              }
              localPi++;
            }

            if (
              (!this.competition.lane_order_type ||
                this.competition.lane_order_type == "Random") &&
              this.progressTo != 5 &&
              this.progressTo != 6
            ) {
              localPi = 0;
              heat.participants = this.$options.filters.shuffle(
                heat.participants
              );
              heat.participants.forEach(p => {
                p.lane = localPi + this.competition.first_lane_no;
                localPi += 1;
              });
            }

            pi = hi + 1;

            round.heats.push(heat);
          });
        });
        return rounds;
      }
    },
    generateCombinedEventPlacingLanes(participantsList) {
      let eventsParticipants = {};

      // Splitting people into their own participants Lists
      participantsList.forEach(member => {
        if (!eventsParticipants[member.events_id]) {
          eventsParticipants[member.events_id] = [];
        }
        eventsParticipants[member.events_id].push(member);
      });

      let heats = [
        {
          label: "Overall Final",
          heatPos: 0,
          ce_overallFinal: 1,
          participants: this.generateParticipantsArray(participantsList)
        }
      ];

      for (const key in eventsParticipants) {
        let heat = {
          label: `${eventsParticipants[key][0]["event_name"]} Final`,
          heatPos: heats.length,
          ce_events_id: key,
          ce_eventFinal: 1,
          participants: this.generateParticipantsArray(
            eventsParticipants[key],
            "event_rank"
          )
        };
        heats.push(heat);
      }

      return [
        {
          label: "Final",
          roundPos: 0,
          isPlacingsRound: 1,
          heats: heats
        }
      ];
    },

    generateParticipantsArray(data, rank = "rank") {
      let participants = [];
      data.forEach((p, index) => {
        participants.push({
          id: p.id,
          events_id: p.events_id,
          lane_id: p.lane_id,
          lane: index + this.competition.first_lane_no,
          pos: index,
          master_time: p.master_time,
          dqCode_id: p.dqCode_id,
          placing:
            typeof p[rank] == "string" ? p[rank].replace("=", "") : p[rank]
        });
      });
      return participants;
    },

    updateProgress() {
      let payload = {
        laneOptions: this.laneOptions,
        progressTo: this.progressTo,
        qualPerRace: this.qualPerRace,
        totalQual: this.totalQual,
        events_id: this.$route.params.events_id
      };
      this.$store.dispatch("eventProgress/drawLanes", payload).then(result => {
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    }
  }
};
</script>
